<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TheDashboardNavigationItem',
  mixins: [baseMixin],
  props: {
    payload: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <v-card
    class="custom-elevation rounded-xl d-flex flex-column justify-center align-center pa-4 overflow-hidden text-center"
    height="100%"
    :to="payload.to"
  >
    <v-card-title class="mb-1">
      <v-icon :color="isActive ? 'blue' : ''" x-large>{{
        payload.icon
      }}</v-icon>
    </v-card-title>
    <v-card-actions>
      <header class="grow">
        <p
          :class="[
            'subtitle-1 font-weight-medium',
            isActive ? 'blue--text' : '',
          ]"
        >
          {{ payload.title }}
        </p>
      </header>
    </v-card-actions>
  </v-card>
</template>
